module.exports = __webpack_public_path__ + "static/img/fanbeimajiang.f5b6381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/fanbeimajiang.png
// module id = Gej+
// module chunks = 0